var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"master scrollable"},[_c('div',{staticClass:"wrapper"},[_c('form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.subscribeToPallet.apply(null, arguments)}}},[_c('router-view',{attrs:{"user":_vm.user,"loading":_vm.loading},on:{"setCode":_vm.setCode,"subscribe":_vm.subscribeToPallet}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }